import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import "../assets/css/login.css";
import * as Yup from "yup";
import LoginInterface from "../types/auth.interface";
// import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { setIsAuthenticated } from "../store/me";
import authService from "../services/auth.service";

const LoginSchema = Yup.object().shape({
  username: Yup.string()
    .min(2, "อย่างน้อย 2 ตัวอักษร!")
    .max(50, "ไม่เกิน 50 ตัวอักษร!")
    .required("กรอก username ด้วยครับ"),
  password: Yup.string()
    .min(3, "อย่างน้อย 3 ตัวอักษร")
    .required("กรอกรหัสด้วยครับ"),
  // name: Yup.string().required("sdfkjsdlfjs;fd"),
});

const Login = () => {
  // const me = useSelector((state: any) => state.me);
  const dispatch = useDispatch();
  // console.log(me);

  const onSubmit = async (value: LoginInterface) => {
    const user = await authService.login(value);

    dispatch(
      setIsAuthenticated({
        isAuthenticated: true,
        firstName: user.firstName ? user.firstName : "",
        lastName: user.lastName ? user.lastName : "",
        role: user.role.name,
      }),
    );
  };

  // const guestLogin = async () => {
  //   const user = await authService.login({
  //     username: "guest",
  //     password: "guest",
  //   });

  //   dispatch(
  //     setIsAuthenticated({
  //       isAuthenticated: true,
  //       firstName: user.firstName ? user.firstName : "",
  //       lastName: user.lastName ? user.lastName : "",
  //       role: user.role.name,
  //     })
  //   );
  // }
  return (
    <div className="text-center loginPage">
      <main className="form-signin">
        <Formik
          validationSchema={LoginSchema} //กำหนด validation Schema
          initialValues={{
            //กำหนด initialValues
            username: "",
            password: "",
          }}
          onSubmit={onSubmit}
          // onSubmit={(values) => {
          //   //handle form submit
          //   console.log(values);
          // }}
        >
          {({ errors, touched }) => (
            <Form>
              <h1 className="h3 mb-3 fw-normal">เข้าสู่ระบบ</h1>
              <h4 className="mb-3 fw-normal">ระบบส่งเอกสาร มคอ. และ อชว.</h4>
              <div className="form-floating">
                <Field
                  name="username"
                  type="text"
                  className="form-control"
                  id="username"
                  placeholder="username"
                />
                <label htmlFor="username">Username</label>
                <ErrorMessage name="username">
                  {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                </ErrorMessage>
              </div>
              <div className="form-floating">
                <Field
                  name="password"
                  type="password"
                  className={`form-control`}
                  id="password"
                  placeholder="Password"
                />
                <label htmlFor="password">Password</label>
                <ErrorMessage name="password">
                  {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                </ErrorMessage>
              </div>

              <button className="w-100 btn btn-lg btn-primary" type="submit">
                เข้าสู่ระบบ
              </button>
            </Form>
          )}
        </Formik>
        <div className="row mt-3">
          <div className="col">
            <a
              href="https://drive.google.com/open?id=1XIuGtcIuSpjXRZbzMv1jFtnGhDMSGpK_&usp=drive_fs"
              className="w-100 btn btn-lg btn-outline-info btn-sm"
            >
              ปฎิทินการส่ง มคอ. และ อชว.
            </a>
          </div>
        </div>
        {/* <div className="row mt-3">
          <div className="col">
            <button
              onClick={guestLogin}
              className="w-100 btn btn-lg btn-outline-info btn-sm text-danger"
            >
              บุคคลทั่วไป
              (Guest User Login)
            </button>
          </div>
        </div> */}
        <p className="mt-5 mb-3 text-muted">© FTE - RMUTI-KKC</p>
      </main>
    </div>
  );
};

export default Login;
